export default "__VITE_ASSET__CVNv0Tj9__"